<template>
  <page-table title="Overview of Proposals" subtitle="All proposals to vote or reject" :total-rows="totalRows" :per-page.sync="perPage" :current-page.sync="currentPage">
    <template v-slot:filter>
      <status-filter v-model="filter" :status-list="statusList" />
    </template>
    <template v-slot:table>
      <b-table striped :items="proposals" :busy="busy" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filter-included-fields="filterOn" :sort-by="sortBy" :sort-desc="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
        <template #cell(status)="data">
          <status :status="data.value" />
        </template>
        <template #cell(description)="data">
          {{ data.item.module }}<span v-if="data.item.description">:&nbsp;{{ data.item.description }}</span>
        </template>
        <template #cell(comments)="data">
          {{ data.value | truncate(50, '......') }}
        </template>
        <template #cell(pending)="data">
          {{ data.item.votes.threshold - (data.item.votes.ayes.length+data.item.votes.nays.length) }}
        </template>
        <template #cell(threshold)="data">
          {{ data.item.votes.threshold }}
        </template>
        <template #cell(voting_status)="data">
          <status :status="data.value" />
        </template>
        <template #cell(transaction)="data">
          <a target="_blank" :href="$BORLAUG + '/proposals/' + data.item.proposal_id"><img src="@/assets/images/orange_bws_logo.png" class="bws-ico"> Borlaug</a>
        </template>
        <template #cell(action)="data">
          <template v-if="data.item.status == 'InProgress'">
            <router-link :to="{name: 'view-proposal', params: {proposalId: data.item.proposal_id}}" class="btn btn-outline-primary" type="button">
              <i class="fa fa-eye" />
            </router-link>
            <button :disabled="data.item.voting_status === 'Approved'" class="btn btn-outline-success ml-1" type="button" @click="vote_yes(data.item)">
              <i class="fa fa-thumbs-up" />
            </button>
            <button :disabled="data.item.voting_status === 'Rejected'" class="btn btn-outline-danger ml-1" type="button" @click="vote_no(data.item)">
              <i class="fa fa-thumbs-down" />
            </button>
          </template>
          <template v-else>
            <router-link :to="{name: 'view-proposal', params: {proposalId: data.item.proposal_id}}" class="btn btn-outline-primary" type="button">
              <i class="fa fa-eye" />
            </router-link>
          </template>
        </template>
        <template #table-busy>
          <div class="text-center  my-5">
            <b-spinner class="align-middle" />
          </div>
        </template>
      </b-table>
    </template>
  </page-table>
</template>

<script>
import { mapGetters } from 'vuex';
import StatusFilter from '@/components/protected/common/StatusFilter.vue';
import PageTable from '@/components/protected/PageTable.vue';
import { proposalStatus } from '@/utils/utils';
import Status from '../common/Status.vue';
import {apiMixin} from '@/utils/api-mixin';

export default {
  name: 'Proposals',
  components: { StatusFilter, PageTable, Status },
  mixins: [apiMixin('audit')],
  data() {
    return {
      fields: [
        {
          key: 'proposal_id',
          label: 'Proposal ID',
          sortable: true
        },
        {
          key: 'status',
          sortable: true
        },
        {
          key: 'description',
          label: 'Name',
          sortable: true
        },
        {
          key: 'comments',
          sortable: true
        },
        {
          key: 'threshold',
          label: 'Votes Required',
          sortable: true
        },
        {
          key: 'pending',
          label: 'Votes Pending',
          sortable: true
        },
        {
          key: 'voting_status',
          label: 'Your Vote',
          sortable: true
        },
        {
          key: 'transaction'
        },
        {
          key: 'action'
        }
      ],
      busy: false,
      proposals: [],
      currentPage: 1,
      filter: 'InProgress',
      filterOn: ['status'],
      sortBy: 'proposal_id',
      sortDesc: false,
      sortDirection: 'asc',
      perPage: 5,
      totalRows: 0,
      statusList: ['Approved', 'Rejected', 'InProgress']
    };
  },
  computed: {
    ...mapGetters(['activeGroup', 'publicKey'])
  },
  watch: {
    proposals(value) {
      this.totalRows = value.length;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async init() {
      await this.getProposals();
    },
    async getProposals() {
      try {
        this.busy = true;
        const { data } = await this.$api.get('/groups/proposals');
        this.proposals = [];
        data.forEach(group => {
          const proposals = group[1];
          proposals.forEach(proposal => {
            proposal.group_id = group[0];
            proposalStatus(proposal, this.publicKey);
            this.proposals.push(proposal);
          });
        });
        console.log(this.proposals);
      } catch (e) {
        console.error(e);
      } finally {
        this.busy = false;
      }
    },
    async vote_yes(proposal) {
      // eslint-disable-next-line no-unused-vars
      let isProposal = false;
      if (this.activeGroup && this.activeGroup.threshold > 1) {
        isProposal = true;
      }
      await this.callApi('loader', isProposal, 'Proposal approved', async () => {
        await this.$api.post(`/groups/groups/${proposal.group_id}/proposals/${proposal.proposal_id}/vote`, {
          approve: true
        }, {
          headers: {
            'API-group-id': proposal.group_id
          }
        });
      })
      await this.init();
      this.$root.$emit('updateNotifications');
    },
    async vote_no(proposal) {
      // eslint-disable-next-line no-unused-vars
      let isProposal = false;
      if (this.activeGroup && this.activeGroup.threshold > 1) {
        isProposal = true;
      }
      await this.callApi('loader', isProposal, 'Proposal rejected', async () => {
        await this.$api.post(`/groups/groups/${proposal.group_id}/proposals/${proposal.proposal_id}/vote`, {
          approve: false
        }, {
          headers: {
            'API-group-id': proposal.group_id
          }
        });
      })
      await this.init();
      this.$root.$emit('updateNotifications');
    }

  }
}
</script>

<style scoped>
</style>
